import { ChangeDetectionStrategy, ChangeDetectorRef, Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { FormlyModule } from '@ngx-formly/core';
import { TranslateModule } from '@ngx-translate/core';
import { FormlyFieldAnyComponent } from '@app/shared/components/formly-components/formly-field-any/formly-field-any.component';

@Component({
  selector: 'app-formly-field-email',
  templateUrl: './formly-field-email.component.html',
  styleUrls: ['./formly-field-email.component.scss'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    CommonModule,
    TranslateModule,
    ReactiveFormsModule,
    FormlyModule,
  ],
})
export class FormlyFieldEmailComponent extends FormlyFieldAnyComponent {
  constructor(private changeDetectorRef: ChangeDetectorRef) {
    super();
  }

  public getMaxLength(): number {
    return this.field.props?.maxLength || 255;
  }

  public getCharacterCount(): number {
    return this.formControl.value?.trim().length || 0;
  }

  public onValueChange(event: any): void {
    const value = event.target?.value || event.detail?.value || '';
    this.onChange(value);
    this.changeDetectorRef.markForCheck();
  }
}